<!-- 收集活动模块 -->
<template>
  <div>
    <!-- 顶部搜索 -->
    <el-form ref="myform"
             size="small"
             :inline="true"
             label-width="58px">
      <el-form-item>
        <el-button v-if="collectingActivitiesAuth>1"
                   @click="openVipDialog()"
                   type="primary"
                   plain
                   size="medium"
                   icon="el-icon-plus">添加收集活动</el-button>
      </el-form-item>
    </el-form>
    <el-card class="box-card">
      <!-- (CURD)操作按钮 -->
      <!-- 表格区域 -->
      <el-table :data="collectActivityLis"
                align="center"
                style="width: 100%"
                :header-cell-style="{background: '#f8f8f9'}">
        <el-table-column prop="title"
                         align="center"
                         label="活动名称">
        </el-table-column>
        <el-table-column prop="startTime"
                         align="center"
                         label="活动开始时间">
        </el-table-column>
        <el-table-column prop="endTime"
                         align="center"
                         label="活动结束时间">
        </el-table-column>

        <el-table-column label="操作">
          <template v-slot="{row}">
            <el-button-group>
              <el-button v-if='collectingActivitiesAuth>0'
                         type="success"
                         size="mini"
                         icon="el-icon-tickets"
                         @click="goto(row.id)">详情</el-button>
              <el-button v-if="collectingActivitiesAuth>1"
                         @click="delCollectActivity(row.id)"
                         type="danger"
                         size="mini"
                         icon="el-icon-delete">删除</el-button>
            </el-button-group>

          </template>
        </el-table-column>

      </el-table>
      <!-- 分页导航 -->
      <template>
        <el-row class="pagination">
          <pagination v-show="total>0"
                      :total="total"
                      :page.sync="queryParams.pageNum"
                      :limit.sync="queryParams.pageSize"
                      @pagination="getCollectActivityList" />
        </el-row>
      </template>
    </el-card>

    <!-- 添加收集活动-->
    <template>
      <el-dialog title="添加收集活动"
                 :visible.sync="addDialogVisible"
                 width="50%">
        <div class="demo-input-suffix">
          <el-form :model="recompose"
                   ref="recompose"
                   :rules="rules"
                   label-width="100px">
            <el-form-item label="标题"
                          prop="title">
              <el-input v-model="recompose.title"
                        placeholder="请输入活动标题"></el-input>
            </el-form-item>
            <el-form-item label="活动时间"
                          prop="data"
                          required>
              <el-date-picker v-model="recompose.data"
                              value-format="yyyy-MM-dd HH:mm"
                              type="datetimerange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="内容"
                          prop="content">
              <el-input v-model="recompose.content"
                        placeholder="请输入内容"></el-input>
            </el-form-item>
            <el-form-item label="封面"
                          prop="cover">
              <el-upload action="api/admin/common/uploadTempFile"
                         ref="upload2"
                         :headers="headers"
                         :limit="1"
                         :data='recompose'
                         :auto-upload="true"
                         list-type="picture-card"
                         :on-remove="handleRemoves"
                         :on-success="uploadFileSuccess">
                <i class="el-icon-plus"></i>
              </el-upload>
              <span style="color:coral">请上传图片类型为jpg或png格式且大小不高于2M的图片</span>
            </el-form-item>

          </el-form>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="resetForm('recompose')">取 消</el-button>
          <el-button type="success"
                     @click="addCollectActivity('recompose')">提交</el-button>
        </span>
      </el-dialog>
    </template>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination
  },
  data() {
    var checkData = (rule, value, callback) => {
      if (value == '') {
        return callback(new Error('请选择活动时间'))
      } else if (value == null) {
        return callback(new Error('请选择活动时间'))
      }

      callback()
    }
    return {
      headers: {
        token: sessionStorage.getItem('token')
      },
      recompose: {
        title: '',
        data: '',
        content: '',
        cover: ''
      },
      collectActivityLis: [],
      //获取用户列表传参
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      // 控制修改密码
      addDialogVisible: false,
      collectingActivitiesAuth: '',
      rules: {
        title: [{ required: true, message: '请输入活动标题', trigger: 'blur' }],
        data: [{ validator: checkData, required: true, trigger: 'change' }],
        cover: [{ required: true, message: '请上传活动封面', trigger: 'change' }]
      },
      addCollectActivityList: {
        title: '',
        startTime: '',
        endTime: '',
        content: '',
        cover: ''
      }
    }
  },
  created() {
    if (this.$route.query.pageNum != 1 && this.$route.query.pageNum != undefined) {
      this.queryParams.pageNum = Number(this.$route.query.pageNum)
    } else {
      this.queryParams.pageNum = 1
    }
  },
  mounted() {
    this.getCollectActivityList()
    this.getAuthAttr()
  },
  methods: {
    handleRemoves(file, fileList) {
      this.recompose.cover = ''
    },
    uploadFileSuccess(response, file) {
      if (response.code == 200) {
        this.$refs.recompose.clearValidate('cover')
        this.recompose.cover = response.data
      } else {
        this.$refs.upload2.clearFiles()
        this.$message.error(response.msg)
      }
    },
    goto(id) {
      this.$router.push({ path: '/collectingActivities/particulars', query: { collectActivityId: id } })
    },
    openVipDialog() {
      this.addDialogVisible = true
      // this.getAddableProductList()
    },
    getAuthAttr() {
      var collectingActivitiesAuth = window.sessionStorage.getItem('auth-18')
      this.collectingActivitiesAuth = collectingActivitiesAuth
    },
    // 获取收集活动列表
    async getCollectActivityList() {
      const { data: res } = await this.$http.get('/admin/collect_activity/getCollectActivityList', { params: this.queryParams })
      this.collectActivityLis = res.data.list
      this.total = res.data.total
    },

    // 删除活动
    async delCollectActivity(id) {
      const msg = await this.$confirm(`你确定要删除本次收集活动吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      if (msg === 'confirm') {
        const { data: res } = await this.$http.get(`/admin/collect_activity/delCollectActivity?collectActivityId=${id}`)
        if (res.code == 200) {
          this.$message.success('删除成功!')
          this.getCollectActivityList()
        } else {
          this.$message.error(res.msg)
        }
      }
    },

    // 添加活动
    addCollectActivity(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.addDialogVisible = false
          this.addCollectActivityList.title = this.recompose.title
          this.addCollectActivityList.startTime = this.recompose.data[0]
          this.addCollectActivityList.endTime = this.recompose.data[1]
          this.addCollectActivityList.content = this.recompose.content
          this.addCollectActivityList.cover = this.recompose.cover
          const { data: res } = await this.$http.post('/admin/collect_activity/addCollectActivity', this.addCollectActivityList)
          if (res.code == 200) {
            this.getCollectActivityList()
            this.$message.success('添加活动成功')
          } else {
            this.$message.warning(res.msg)
          }
          this.$refs[formName].resetFields()
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.addDialogVisible = false
    }
  }
}
</script>
<style lang='scss' scoped>
</style>